import React from 'react';
import { RoadPavement } from '../../../../../../../services/types/Calculator';
import RoadPavementDetailsBase from './RoadPavementDetailsBase';

interface Props {
  roadPavement: RoadPavement;
}

const RoadPavementDetailsTransport: React.FC<Props> = ({ roadPavement }) => {
  const calculateFactorTotalArea = (rp: RoadPavement): number => rp.factorValue;

  const calculateFactorValue = (rp: RoadPavement): number => rp.factorValue;

  return (
    <RoadPavementDetailsBase
      roadPavement={roadPavement}
      calculateFactorTotalArea={calculateFactorTotalArea}
      calculateFactorValue={calculateFactorValue}
    />
  );
};

export default RoadPavementDetailsTransport;
